import api from "./api";

export interface PessoaOnline {
  id: string;
  nome: string;
  email: string;
  perfil: string;
  fotoUrl?: string | null;
  online: boolean;
}

export async function listarPessoas() {
  const r = await api.get("/presence");
  return r.data.data as PessoaOnline[];
}
